// extracted by mini-css-extract-plugin
export default {"tweetList":"AdminTweetList_tweetList__ao8S+","spinner":"AdminTweetList_spinner__vfh29"};